import { FC } from 'react'

import IconClose from 'images/icon-close-blue.svg'

import styles from './styles.module.scss'

interface FilterTabProps {
  label: string
  onClick: () => void
}

const FilterTab: FC<FilterTabProps> = ({ label, onClick }) => (
  <button onClick={onClick} className={styles.btn} type="button">
    <span className={styles.label}>{label}</span>
    <img src={IconClose} className={styles.img} alt="close" />
  </button>
)

export default FilterTab
